import TemplateView from '../../../../../TemplateView'
import {paymentMethod} from '../../../constants'
import CustomRadioButton from '../CustomRadioButton'
import messageResource from '../../../../../messageResource'

export default class PaymentMethodChooser extends TemplateView {

    constructor({
        onCreditCardButtonClick = () => {},
        onTransferButtonClick = () => {},
        onCheckButtonClick = () => {},
    } = {}) {
        super()

        this.callbacks = {
            onCreditCardButtonClick,
            onTransferButtonClick,
            onCheckButtonClick,
        }

        this.state = {
            paymentMethod: 0,
            canPayByCheck: true,
        }

        this.onStatePropertyChanged('canPayByCheck', (canPayByCheck) => {
            this.$checkButton.toggle(canPayByCheck)
            this.$wireTransferButton.toggleClass('withoutCheck', !canPayByCheck)
        })

        this.onStatePropertyChanged('paymentMethod', () => {
            this._refreshRadioButtons()
        })
    }

    templateHtml() {
        return '<div class="paymentMethodChooser">' +
               '    <div class="title"><%=title%></div>' +
               '    <div class="buttonsContainer">' +
               '        <div class="creditCard"/>' +
               '        <div class="wireTransfer"/>' +
               '        <div class="check"/>' +
               '    </div>' +
               '</div>'
    }

    messageKeys() {
        return {
            title: 'licenses.purchase.purchase_step.payment_chooser_title',
        }
    }

    afterRender() {
        this.$cardButton = this.find('.creditCard')
        this.$wireTransferButton = this.find('.wireTransfer')
        this.$checkButton = this.find('.check')

        this.cardButton = new CustomRadioButton({
            radioWrapperAdditionalClass: 'cardButton',
            label: messageResource.getMessage('licenses.purchase.purchase_step.card'),
            name: 'payment',
            onChangeCallback: this.callbacks.onCreditCardButtonClick,
        }).init(this.$cardButton)

        this.wireTransferButton = new CustomRadioButton({
            radioWrapperAdditionalClass: 'wireTransferButton',
            label: messageResource.getMessage('licenses.purchase.purchase_step.wire_transfer'),
            name: 'payment',
            onChangeCallback: this.callbacks.onTransferButtonClick,
        }).init(this.$wireTransferButton)

        this.checkButton = new CustomRadioButton({
            radioWrapperAdditionalClass: 'checkButton',
            label: messageResource.getMessage('licenses.purchase.purchase_step.check'),
            name: 'payment',
            onChangeCallback: this.callbacks.onCheckButtonClick,
        }).init(this.$checkButton)
    }

    _refreshRadioButtons() {
        this.cardButton.setState({selected: this.state.paymentMethod === paymentMethod.CC})
        this.wireTransferButton.setState({selected: this.state.paymentMethod === paymentMethod.WIRE})
        this.checkButton.setState({selected: this.state.paymentMethod === paymentMethod.CHECK})
    }
}



// WEBPACK FOOTER //
// ./web/js/administration/licenses/components/purchaseLightBox/paymentStep/PaymentMethodChooser.js